
var attachTabsDivShow = function () {
    var tabsTop = $('#tabstop');
    var active = tabsTop.data('active');
    var disableswitch = tabsTop.data('disableswitch');
    var mapLoaded = false;

    if (window.location.hash != '' && window.location.hash != '#pricestable') {
        active = window.location.hash.substring(1);

        //console.log(active)

        $('ul.tabs a').removeClass('active');
        $('ul.tabs a').each(function () {
            if ($(this).data('type') == active) {
                $(this).addClass('active');
                $('#' + active).addClass('active');
            }
        });

        new scrollToDiv(tabsTop);
    }

    /*
    $('div.toggle').each(function () {
      if ($(this).attr('id') != active) {
        $(this).hide();
      }
    });
    */

    if (window.location.hash == '#pricestable') {
        window.location.hash = '';

        $(window).on('load', function () {
            new scrollToDiv($('#pricestable-top'));
        });
    }

    if (disableswitch == 0 && active != 'q-and-a') {
        $('ul.tabs a[class!="disabled"]').click(function (event) {
            event.preventDefault();

            if ($(this).hasClass('lightbox')) {
                window.fancybox.open({
                    src: $(this).attr('href'),
                    type: 'iframe'
                });

                /*
                $.colorbox({
                    href: $(this).attr('href'),
                    iframe: true,
                    padding: 0,
                    maxWidth: 820,
                    width: '100%',
                    maxHeight: 820,
                    height: '90%',
                    close: '<span class="icon-close"></span>'
                });
                */
            } else {
                $('ul.tabs a').removeClass('active');

                $('div.toggle').each(function () {
                    $(this).hide();
                });

                $('#' + $(this).data('type')).fadeIn();

                new scrollToDiv(tabsTop);

                $(this).addClass('active');

                if ($(this).data('type') == 'about') {
                    window.location.hash = '';
                } else {
                    window.location.hash = $(this).data('type');
                }

                if ($(this).data('type') == 'where') {
                    if (!mapLoaded) {
                        new locationsetup(markers[0][1], markers[0][2], 11, 0, 0, 0, '');
                        mapLoaded = true;
                    }
                }
            }
        });
    }

    if (!mapLoaded && active == 'where') {
        $.ajaxSetup({
            cache: true
        });
        $.getScript("https://maps.google.com/maps/api/js?key=" + googleMapsAPIKey)
            .done(function (script, textStatus) {
                googleMapsAPILoaded = true;
                new locationsetup(markers[0][1], markers[0][2], 11, 0, 0, 0, '');
                mapLoaded = true;
            });
    }
};

var attachTabs = function (itemid, regionid, url, inc, popupvar) {
    var title = document.title;
    var tabTextArray = Array();
    var div = $('#inner');
    var tabsTop = $('#tabstop');

    var t = 0;
    $('ul.tabs a').each(function () {
        tab = $(this);

        tabTextArray[t] = ' - ' + tab.text();

        t++;
    });

    $('ul.tabs a[class!="disabled"]').each(function () {
        if ($(this).data('type') != 'where') {
            $(this).click(function (event) {
                datatype = $(this).data('type');

                tab = $(this);

                $('ul.tabs').addClass('loading');

                new scrollToDiv(tabsTop);

                $.ajax({
                    type: 'GET',
                    url: '/inc/' + inc + '.php',
                    data: 'datatype=' + datatype + '&itemid=' + itemid + '&regionid=' + regionid + '&url=' + url,
                    success: function (response) {
                        div.html(response);
                        div.fadeTo(300, 1);

                        for (t = 0; t < tabTextArray.length; t++) {
                            title = title.replace(tabTextArray[t], '');
                        };

                        if (datatype != '') {
                            document.title = title + ' - ' + tab.text();
                        }

                        $('ul.tabs').removeClass('loading');
                        $('ul.tabs a').removeClass('active');
                        $('ul.tabs li.' + (datatype == '' ? 'about' : datatype) + ' a').addClass('active');

                        new links(popupvar);

                        new expandableText('div.js-expandable', 0);

                        if (datatype == 'reviews') {
                            $('input.star').rating();
                            new revealReviews('revealreviews');
                        }
                    }
                });

                event.preventDefault();
            });
        }
    });
};

new attachTabsDivShow();